import { SupplyIntelUnitAvailableSchema } from "@redotech/redo-inventory-common/supply-intel/unit-available";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** One brand's units the dashboard recommends reselling, as `UnitAvailable` records for Relist; read fresh from Snowflake. */
export const getSupplyIntelUnitAvailable = unaryRpc({
  name: "getSupplyIntelUnitAvailable" as const,
  input: z.object({ accountId: z.string().regex(/^\d{1,19}$/) }),
  output: z.object({
    units: z.array(SupplyIntelUnitAvailableSchema),
    /** The brand's units hit the read limit, so some are missing. */
    truncated: z.boolean(),
    configVersion: z.string(),
    generatedAt: z.date(),
  }),
});
